const engravingTextObservable = {
  _value: "",

  get value() {
    return this._value;
  },

  set value(newValue) {
    if (newValue !== this._value) {
      this._value = newValue;
      document.dispatchEvent(new CustomEvent('engravingTextChanged', { detail: newValue }));
    }
  }
};

const engravingInProgressObservable = {
  _value: false,

  get value() {
    return this._value;
  },

  set value(newValue) {
    if (newValue !== this._value) {
      this._value = newValue;
      document.dispatchEvent(new CustomEvent('engravingInProgressChanged', { detail: newValue }));
    }
  }
};
